/**
 * Discriminator values for the message data `type` field.
 *
 * Kept in its own module so per-type modules can reference their own literal
 * without importing the catalog that collects them — the catalog imports the
 * types, so the reverse edge would be a cycle.
 */
export const MESSAGE_DATA_TYPES = {
  REFERENCE: 'reference',
  ANSWER: 'answer',
  PRIMUM_SUPPORT: 'primum_support',
  /** Ask Anonymously / support: relayed expert copy → Twilio attributes.contentRole */
  EXPERT_RELAY: 'expert_relay',
  /**
   * Primum Support copy posted into an inquiry conversation by staff, carrying
   * an `audience` naming which participant it is for.
   *
   * Distinct from `PRIMUM_SUPPORT`, which the app writes when an internal
   * viewer sends as Primum Support from the composer. This one is written by
   * the backend's support-message route and is the only type carrying an
   * audience.
   *
   * The audience is a RENDER-TIME GATE, NOT A CONFIDENTIALITY BOUNDARY: both
   * participants hold a Twilio grant on the conversation and both clients
   * receive every body, so hiding it only keeps it out of the UI.
   */
  SUPPORT_MESSAGE: 'support_message',
  /** Medical On Demand inquiry — stores selected product IDs in Twilio message attributes */
  MOD_INQUIRY: 'mod_inquiry',
  /**
   * Fellows Corner mentorship inquiry. Tags the inquiry with the mentor it was
   * sent to so the backend can route it: a platform-expert mentor receives a
   * direct conversation, a non-user mentor (e.g. an attorney with no account)
   * is relayed through Primum Support.
   */
  MENTOR_INQUIRY: 'mentor_inquiry',
  /**
   * Content suggestion — auto-posted by the backend when a Content Library
   * article is matched to an inquiry. Carries a self-contained `contentCard`
   * so the app renders a "While you wait" suggestion to the submitter without
   * a separate fetch.
   */
  CONTENT_SUGGESTION: 'content_suggestion',
} as const;

export type MessageDataType = (typeof MESSAGE_DATA_TYPES)[keyof typeof MESSAGE_DATA_TYPES];
